<template>
   <div  v-if="isLoading" class="calculation-spinner flex flex-center">
    <q-spinner-facebook size="3em" color="primary" />
</div>
<div v-else>
      <div   v-if="historicMessages && historicMessages.length ===0" class="text-deep-black-4 font-weight-normal mt-3">
          <span>  {{ $t("order.orderActions.NoMessagesFound") }}  </span>
      </div> 
  <div v-for="(m, mIndex) in historicMessages" :key="mIndex"
    class="tw-notification-container tw-historic-messsage-container border-bottom p-3 d-flex justify-between"
    :class="{ 'tw-notification-status-NEW': shouldChangeColor(m.messagePack[0]) }">
    <div class="tw-notfication-content w-100">
      <div class="d-flex justify-content-between align-items-start">
        <div>
          <span class="font-size-14 font-medium" :class="{ 'text-primary': shouldChangeColor(m.messagePack[0]) }">
            {{ m.messagePack[0].subject }}
            <q-badge rounded v-if="shouldChangeColor(m.messagePack[0])" color="blue" />
          </span>

          <div v-if="activeSubjectUid !== mIndex">
            <span :class="{
              'text-dark': !shouldChangeColor(m.messagePack[0]),
              'text-primary': shouldChangeColor(m.messagePack[0]),
            }">
              <span class="text-muted">{{ useDate.withPattern(m.messagePack[0].date, Masks.timestampMask_Sys) }} - </span>

              <span class="font-size-12">
                {{ m.messagePack[0].sender }}
                <a class="text-primary">
                  {{ $t("communication.comMessage.send") }}
                </a>
                {{ $t("communication.comMessage.sendMessage") + recipientLabel(m.messagePack[0]) }}
              </span>
            </span>
          </div>

        </div>
        <div class="tw-notification-actions">

          <q-btn v-if="Number(toggleCountMessage(m.messagePack)) !== 1" @click="toggleList(mIndex)"
            class="tw-button-message badge badge-primary d-flex align-items-center pl-2 pr-2 pt-2 pb-2"
            icon="question_answer" size="sm" :label="toggleCountMessage(m.messagePack)"></q-btn>
        </div>

      </div>

      <div v-if="activeSubjectUid !== mIndex">

        <div class="bg-white p-2 border default-border-radius tw-notification-comment-wrapper mt-2">
          <span class="d-flex" :class="m.messagePack[0].showComment ? '' : 'tw-truncate-text-comment'">
            {{ m.messagePack[0].showComment ? m.messagePack[0].body : truncatedText(m.messagePack[0].body) }}
          </span>
          <span v-if="shouldDisplayShowCommentButton(m.messagePack[0])">
            <button class="btn p-0 bg-transparent text-primary" style="text-decoration: underline !important"
              @click="toggleComment(m.messagePack[0])">
              {{
                !m.messagePack[0].showComment
                ? $t("communication.comNotification.showMore")
                : $t("communication.comNotification.showLess")
              }}
            </button>
          </span>
        </div>

      </div>

      <div v-if="activeSubjectUid === mIndex">
        <ul class="pl-3 mb-0">
          <li v-for="(msg, msgIndex) in m.messagePack" :key="msgIndex" class="tw-list-style mt-2 pb-3">
            <span :class="{
              'text-dark': !shouldChangeColor(msg),
              'text-primary': shouldChangeColor(msg),
            }">
              <span class="text-muted">{{ useDate.withPattern(msg.date, Masks.timestampMask_Sys) }} -</span>

              <span class="font-size-12">
                {{ msg.sender }}
                <slot v-if="msg.replymsgparent">
                  <a class="text-primary">
                    {{ $t("communication.comMessage.response") }}
                  </a>
                  {{ $t("communication.comMessage.responseMessage") }}
                </slot>
                <slot v-else-if="msg.transfermsgparent">
                  <a class="text-primary">
                    {{ $t("communication.comMessage.tansfert") }}
                  </a>
                  {{ $t("communication.comMessage.tansfertMessage") + recipientLabel(msg) }}
                </slot>
                <slot v-else>
                  <a class="text-primary">
                    {{ $t("communication.comMessage.send") }}
                  </a>
                  {{ $t("communication.comMessage.sendMessage") + recipientLabel(msg) }}
                </slot>
              </span>
              <q-badge rounded v-if="shouldChangeColor(msg)" color="blue" />
            </span>
            <div class="bg-white tw-notification-comment-wrapper">
              <span class="d-flex">
                {{ msg.body }}
              </span>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
  </div>
</template>

<script lang="ts">
import store from "@/store";
import {Options, Vue} from "vue-class-component";
import {mapActions} from "vuex";
import {Masks, useDate} from "@/utils";
import i18n from "@/i18n";

@Options({
  props: ["entityState"],
  computed: {
    Masks() {
      return Masks
    },
    useDate() {
      return useDate
    }
  },
  methods: {
    ...mapActions(
        {
          callHistoricMessages: "messagingModule/historicMessages"
        }
    )
  },
  /**
   * Fetches historic messages when the component is created.
   *
   * @function
   * @name created
   */
  created() {
    this.callHistoricMessages({
      type: "MESSAGE",
      entityId: this.entityState.reference || this.orderSummary.reference,
    }).then(() => {
     this.historicMessages ? this.isLoading = false : this.isLoading = true
    })
  }
})
export default class SummaryMessage extends Vue {

  showComment?: boolean = false;
  showMessage = true;
  activeSubjectUid = null;
  isLoading = true
  /**
   * Gets historic messages from the store.
   *
   * @function
   * @name historicMessages
   * @returns any[] The historic messages.
   */
  get historicMessages(): any[] {
    return store.getters["messagingModule/getHistoricMessages"].sort((a:any, b:any) => {
      return new Date(b.messagePack[0].date).getTime() - new Date(a.messagePack[0].date).getTime();
    });
  }
  get orderSummary() {
    return store.state.summaryPanelModule.order;
  }

  /**
   * Toggles the display of message details for a group.
   *
   * @function
   * @name toggleList
   * @param {any} groupIndex - The index of the message group to toggle.
   */
  toggleList(groupIndex: any) {
    this.activeSubjectUid =
      this.activeSubjectUid === groupIndex ? null : groupIndex;
    this.showMessage = false;
  }

  /**
   * Toggles the display of comments for a message.
   *
   * @function
   * @name toggleComment
   * @param {any} item - The message item to toggle comments for.
   */

  toggleComment(item: any) {
    item.showComment = !item.showComment;
  }

  /**
   * Truncates text if it exceeds a certain length.
   *
   * @function
   * @name truncatedText
   * @param {string} text - The text to truncate.
   * @returns {string} The truncated text.
   */

  truncatedText(text: string): string {
    if (text.length <= 100) {
      return text;
    }
    return text.slice(0, 100) + (this.showComment ? "" : "...");
  }

  /**
   * Checks if a "Show More" button should be displayed for a message.
   *
   * @function
   * @name shouldDisplayShowCommentButton
   * @param {any} item - The message item to check.
   * @returns {boolean} `true` if the button should be displayed; otherwise, `false`.
   */
  shouldDisplayShowCommentButton(item: any): boolean {
    return item.body.length > 100;
  }

  /**
   * Gets the count of message details for a group.
   *
   * @function
   * @name toggleCountMessage
   * @returns {string} The count of message details.
   * @param groupMessages
   */
  toggleCountMessage(groupMessages: any): string {
    return groupMessages.length;
  }

  /**
   * Checks if a message group should have a color change.
   *
   * @function
   * @name shouldChangeColor
   * @param {any} groupMessage - The object of the message group to check.
   * @returns {boolean} `true` if the color should change; otherwise, `false`.
   */
  shouldChangeColor(groupMessage: any): boolean {
    return groupMessage.status === "NEW";
  }

  /**
   * set the correct group name
   * @param code of the group
   * @returns string for the group name
   */
  setGroupName(code: string): string {
    // message envoyé uniquement par email : aucun destinataire interne n'est enregistré
    if (!code) return "";
    const groupName = `${i18n.global.t('middleOffice.decision.profil.'.concat(code))}`;
    return groupName.includes('middleOffice') ? code : groupName;
  }

  /**
   * libellé du destinataire : utilisateur, puis groupe, puis la trace « Recipients »
   * posée à l'envoi (seul endroit où une adresse email est conservée)
   * @param msg message de l'historique
   * @returns string le destinataire à afficher
   */
  recipientLabel(msg: any): string {
    return msg?.recipientname || this.setGroupName(msg?.recipient_resourceuid) || msg?.recipientlabel || "";
  }

}
</script>

<style scoped>
.background-color {
  background-color: rgb(65 65 65 / 7%);
}

.text-primary {
  font-weight: 600;
}

.q-badge {
  margin-left: 3px;
}
</style>
